<app-master-page>
  <app-modelo></app-modelo>
</app-master-page>

